import { render, staticRenderFns } from "./FirstStepContainer.vue?vue&type=template&id=ed65f1b8&lang=html&"
import script from "./FirstStepContainer.vue?vue&type=script&lang=ts&"
export * from "./FirstStepContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports